<template>
  <div
    :class="{
      'consult-navbar': true,
      'common-basic-app-status-bar-padding-top': true,
      headerFix: fixed && headerFix
    }"
    v-if="show"
    ref="navbar"
  >
    <!--
      common-basic-app-status-bar-padding-top
      在app.vue layout.vue 插入的
     -->
    <div
      :style="{ color: color }"
      :class="{
        'consult-navbar-container': true,
        'common-basic-app-status-bar-padding-top': fixed,
        fixed: fixed
      }"
    >
      <slot name="fixed-slot" />
      <div class="goback" v-if="showGoback" @click="goback">
        <icon name="weibiaoti--" />
      </div>
      <div v-if="isShowSearch" class="search" @click="$emit('search')">
        <div v-if="showHeaderCenter" class="search-wrap">
          <svg-search-new class="ic-search" :color="color" />
          <span>{{ searchPlaceholder }}</span>
        </div>
      </div>
      <div class="center" :style="{ color: color }">
        <transition name="fade"
          ><span v-if="title && showTitle">{{ title }}</span
          ><slot v-if="showTitle"
        /></transition>
      </div>
      <div v-if="isShowSearch" class="search big" @click="$emit('search')">
        <svg-search-new
          v-if="!showHeaderCenter"
          class="ic-search"
          :color="color"
        />
      </div>

      <div class="share" v-if="!isHideShare" @click="share">
        <svg-share-square class="ic-share" :color="color" />
      </div>

      <div class="services" @click="$emit('toServices')" v-if="isServicesIcon">
        <img :src="isServicesIcon" alt="" />
      </div>
    </div>
  </div>
</template>

<script>
import svgShareSquare from './svgIcon/svg-share-square.vue'
import svgSearchNew from './svgIcon/svg-search-new.vue'
export default {
  components: { svgShareSquare, svgSearchNew },
  props: {
    title: {
      type: String,
      default: ''
    },
    showTitle: {
      type: Boolean,
      default: false
    },
    fixed: {
      type: Boolean,
      default: false
    },
    headerFix: {
      type: Boolean,
      default: false
    },
    show: {
      type: Boolean,
      default() {
        return this.canHideNavigationBar
      }
    },
    shareConfig: {
      type: [Object],
      default() {
        return this.$isServer ? {} : this.$parent.shareConfig
      }
    },
    color: {
      type: String,
      default: ''
    },
    showGoback: {
      type: Boolean,
      default: true
    },
    isShowSearch: {
      type: Boolean,
      default: false
    },
    showHeaderCenter: {
      type: Boolean,
      default: false
    },
    searchPlaceholder: {
      type: String,
      default: ''
    },
    isServicesIcon: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      paddingTop: 0
    }
  },
  computed: {
    isHideShare() {
      const {
        isYixinliApp,
        isMuseApp,
        isCeShiApp,
        isZiXunApp,
        isQingSuApp,
        isZiXunShiApp
      } = this.$platform
      const isApp =
        isYixinliApp ||
        isMuseApp ||
        isCeShiApp ||
        isZiXunApp ||
        isQingSuApp ||
        isZiXunShiApp
      // 壹心理APP的分享有微博，咨询APP没微博，只有微信。 到时候审核直接被拒
      if (isApp) return this.$route.query.sshzv == 1 || !this.shareConfig
      return true
    }
  },
  methods: {
    goback() {
      this.routerGoback()
      // this.$bridge.cancelWebView()
    },
    shareStat(properties = {}) {
      const { business, pageName } = this.$route.meta
      // 没定义就不继续了
      if (!business) {
        console.warn(
          '微信分享mixin警告：路由没有定义meta.business, pageName， 埋点失败'
        )
        return
      }

      const { link, title, desc } = this.shareConfig
      const _properties = {
        href: window.location.href,
        UA: window.navigator.userAgent,
        页面title: document.title,
        title: pageName || '',
        App版本: this.$route.query._version || '',
        社交类型: '分享',
        分享目标: properties.channel || '',
        分享标题: title,
        分享描述: desc,
        分享链接: link,
        行为分类: '点击分享按钮'
      }
      this.$stat.send({
        name: `${business}-社交行为`,
        properties: _properties
      })
    },
    share() {
      const { shareConfig } = this
      this.shareStat()
      if (shareConfig && Object.keys(shareConfig).length) {
        this.$bridge.shareReport(shareConfig)
      }
      this.$emit('share')
    },

    // 对外暴露，需保留
    getHeight() {
      return new Promise(resolve => {
        const { isYixinliApp, isZiXunApp, isQingSuApp } = this.$platform
        this.getHeightTimer = setTimeout(
          () => {
            const { navbar } = this.$refs
            resolve(navbar ? navbar.offsetHeight - 2 : 0)
          },
          // 延迟是因为可能app下需要等待statusbar height
          isYixinliApp || isZiXunApp || isQingSuApp ? 200 : 30
        )
      })
    }
  },
  destroyed() {
    clearTimeout(this.getHeightTimer)
  }
  // created() {
  //   if (!this.$isServer) {
  //     this.$bridge.hasNotch().then(({ statusBarHeight }) => {
  //       this.paddingTop = statusBarHeight
  //     })
  //   }
  // }
}
</script>

<style lang="scss">
.consult-navbar {
  position: relative;
  z-index: $navbarZIndex;
  height: 90px;
  &.headerFix {
    position: fixed;
    left: 50%;
    margin-left: -375px;
    width: 750px;
    top: -2px;
  }
  &-container {
    display: flex;
    height: 90px;
    color: #fff;
    padding: 0 20px;
    align-items: center;
    // box-sizing: border-box;
    &.fixed {
      position: fixed;
      left: 50%;
      margin-left: -375px;
      width: 750 - 20 - 20px; // 因为padding
      top: -2px;
    }
  }
  .center {
    flex: 1;
    font-size: 36px;
    color: #ffffff;
    display: flex;
    z-index: -1;
  }
  .center,
  .share,
  .search,
  .services,
  .goback {
    height: 100%;
    display: flex;
    align-items: center;
    position: relative;
    .icon-node-website {
      font-size: 40px;
    }
  }
  .center {
    position: static;
  }
  .share {
    margin: 0 20px;
    .ic-share {
      width: 0.58667rem;
      height: 0.58667rem;
    }
  }
  .goback {
    padding-left: 3px;
    padding-right: 29.4px;
  }
  .search {
    position: relative;
    .search-wrap {
      width: 550px;
      height: 68px;
      background: #f3f4f5;
      border-radius: 34px;
      display: flex;
      align-items: center;

      span {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        color: #6c798c;
      }
      .ic-search {
        margin: 0 20px;
      }
    }
    &.big {
      .ic-search {
        width: 0.58667rem;
        height: 0.58667rem;
      }
    }
    .ic-search {
      width: 0.42667rem;
      height: 0.42667rem;
      margin: 0 20px;
    }
  }
  .services {
    margin: 0 20px;
    img {
      width: 0.58667rem;
      height: 0.58667rem;
    }
  }
}
</style>
